import React from 'react';
import DetailsListItem from 'modules2/components/DetailsListItem';
import { ListViewSkeleton } from 'common/ui/skeleton-ui';
import { scrollToMainContent } from 'common/ui/utils';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  emptytext: {
    textAlign: 'center',
    width: '100%',
    position: 'relative',
    paddingBottom: theme.spacing(1),
    fontFamily: theme.typography.fontFamily
  },
  nodatalink: {
    color: 'rgb(255, 0, 102)',
    cursor: 'pointer'
  },
  description: {
    position: 'relative',
    marginBottom: 20
  }
}));

const popularList = (props, loading) => {
  const { radios } = props;

  if (loading) {
    return [...Array(3)].map((_, idx) => {
      return <ListViewSkeleton key={idx} />;
    });
  }

  return Object.keys(radios)
    .slice(0, 3)
    .map((id) => {
      return (
        <DetailsListItem
          editable={false}
          key={radios[id].stationuuid}
          stationid={radios[id].stationuuid}
          isPlayed={false}
          isPinned={false}
          image={radios[id].favicon}
          title={radios[id].name}
          subtitle={radios[id].tags}
          url={radios[id].url_resolved}
          radio_id={radios[id].stationuuid}
          radio={radios[id]}
          onClick={props.onClickHandler}
          // onDeleteClick={props.onDeleteClick}
          onFavouriteClick={props.onFavouriteClick}
        />
      );
    });
};

const NoData = (props) => {
  const classes = useStyles();
  const { loading, message } = props;

  const onListItemClick = (tab) => {
    props.onSetCurrentTab(tab);
    scrollToMainContent();
  };

  return (
    <>
      <div className={classes.emptytext}>
        {message} Listen to some{' '}
        <span className={classes.nodatalink} onClick={onListItemClick}>popular radio</span>{' '}stations.
      </div>
      {/*{loading && (
        <div className={classes.description}>
          <CircularProgress color="primary" />
        </div>
      )}*/}
      {popularList(props, loading)}
    </>
  );
};

export default NoData;
